import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import strings from '../../components/locales/';

/* Function */
import ObjGeneral from '../function/';
/* Local store */
import { localStoreFN } from '../../store/localStorage';
/* Actions */
import * as summaryNfaActions from '../../actions/summary_nfa/index';
import * as detailNfaActions from '../../actions/detail_nfa/index';

/* Components */
import { Tooltip } from 'react-bootstrap';
import Header from '../../components/summary_nfa/header';
import TitleMain from '../../components/summary_nfa/title';
import Main from '../../components/summary_nfa/main';
import TitleSecond from '../../components/summary_nfa/titleSecond';
import Buttons from '../../components/summary_nfa/buttons';
import Table from '../../components/summary_nfa/table';

import Loading from '../../components/common/loading';
import Message from '../../components/common/message';
import Expired from '../expired/index';

class SummaryNfa extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pag: 1,
      select: '',
      tags: [],
      arrTags: [],
      countBPM: 0,
      range: [1, 10],
      sum: 10,
      sort: {
        alias: null,
        risk: null,
        evolution: null,
        distribution: null,
        ndrivers: null,
        ninRisk: null
      }
    };
  }

  async componentDidMount() {
    // get the permissions to validate the view
    const permits = localStoreFN().getItem('permits');
    const permit = permits.includes('nfa');
    if (permit) {
      if (this.props.setting) {
        // get the setting objects
        const obj = JSON.parse(this.props.setting.value);
        if (obj.generalSetting.views.includes('nfa')) {
          let main;
          if (obj.summaryTruck) {
            main = obj.summaryNFA.main ? obj.summaryNFA.main : obj.generalSetting.main;
          } else {
            main = obj.generalSetting.main;
          }

          // we bring the persisted data
          const dateStart = this.props.filters.date.fechaStartFinal || null;
          const dateEnd = this.props.filters.date.fechaEndFinal || null;
          const mainPers = this.props.filters.main || main;
          // eslint-disable-next-line react/no-did-mount-set-state
          this.setState({ select: mainPers });

          // call to Form's fetch api
          await this.props.actions.fetchSummaryNfaBPMApi({
            main: mainPers,
            dateStart,
            dateEnd,
            pag: this.state.pag
          });
          await this.props.actions.fetchSummaryNfaTableApi({
            main: mainPers,
            dateStart,
            dateEnd,
            pag: this.state.pag
          });
          await this.props.actions.fetchSummaryNfaTableCountApi({
            main: mainPers,
            dateStart,
            dateEnd
          });
          await this.props.actions.fetchSummaryNfaApi({});
          // COUNT fetch api call
        } else {
          // not authorized
          this.props.history.push('/dashboard/authorization');
        }
      }
    } else {
      // not authorized
      this.props.history.push('/dashboard/authorization');
    }
  }

  // we load the reset function, return the states to their initial state
  componentWillUnmount() {
    this.props.actions.resetSummaryNfa();
  }

  // function performed to sort the table
  handleSort = async event => {
    /* Change sort */
    const sort = { ...this.state.sort };
    if (event.currentTarget.dataset.type === 'alias') {
      sort.risk = null;
      sort.evolution = null;
      sort.distribution = null;
      sort.ndrivers = null;
      sort.ninRisk = null;
    } else if (event.currentTarget.dataset.type === 'risk') {
      sort.alias = null;
      sort.evolution = null;
      sort.distribution = null;
      sort.ndrivers = null;
      sort.ninRisk = null;
    } else if (event.currentTarget.dataset.type === 'evolution') {
      sort.alias = null;
      sort.risk = null;
      sort.distribution = null;
      sort.ndrivers = null;
      sort.ninRisk = null;
    } else if (event.currentTarget.dataset.type === 'distribution') {
      sort.alias = null;
      sort.risk = null;
      sort.evolution = null;
      sort.ndrivers = null;
      sort.ninRisk = null;
    } else if (event.currentTarget.dataset.type === 'ndrivers') {
      sort.alias = null;
      sort.risk = null;
      sort.evolution = null;
      sort.distribution = null;
      sort.ninRisk = null;
    } else if (event.currentTarget.dataset.type === 'ninRisk') {
      sort.alias = null;
      sort.risk = null;
      sort.evolution = null;
      sort.distribution = null;
      sort.ndrivers = null;
    }
    const value = this.state.sort[event.currentTarget.dataset.type] == 'DESC' ? 'ASC' : 'DESC';
    sort[event.currentTarget.dataset.type] = value;
    /* Get Date */
    const objDate = JSON.parse(this.props.setting.value);
    const format = this.props.language.account.date.format;
    const date = ObjGeneral.getDate({ id: null }, format);
    /* Set sort */
    this.setState({
      sort
    });
    /* Set Pag */
    this.setState({ pag: 1 });
    /* Fetch */
    await this.props.actions.fetchSummaryNfaBPMApi({
      sort,
      pag: 1,
      main: this.state.select,
      dateStart: date.fechaStartFinal,
      dateEnd: date.fechaEndFinal
    });
    await this.props.actions.fetchSummaryNfaTableNoLoadingApi({
      sort,
      pag: 1,
      main: this.state.select,
      dateStart: date.fechaStartFinal,
      dateEnd: date.fechaEndFinal
    });
  };

  // function made to filter by main and date
  handleSubmit = async obj => {
    /* Get Select */
    const group = document.getElementById('group').value;
    this.setState({ select: group });
    /* Get Date */
    const objDate = JSON.parse(this.props.setting.value);
    const format = this.props.language.account.date.format;
    const date = ObjGeneral.getDate(obj, format);
    /* Set Pag */
    this.setState({ pag: 1 });
    // set filter to persist
    this.props.actions.setFilterSummaryNfa({
      date,
      main: group
    });

    /* Fetch */
    await this.props.actions.fetchSummaryNfaTableCountApi({
      dateStart: date.fechaStartFinal,
      dateEnd: date.fechaEndFinal,
      main: group,
      pag: 1,
      tags: this.state.arrTags
    });
    await this.props.actions.fetchSummaryNfaTableApi({
      dateStart: date.fechaStartFinal,
      dateEnd: date.fechaEndFinal,
      main: group,
      sort: this.state.sort,
      tags: this.state.arrTags,
      pag: 1
    });
    await this.props.actions.fetchSummaryNfaApi({
      dateStart: date.fechaStartFinal,
      dateEnd: date.fechaEndFinal,
      main: group,
      sort: this.state.sort,
      tags: this.state.arrTags,
      pag: 1
    });
  };

  handleTagsFilter = async event => {
    const select = event.currentTarget.dataset.select;
    const parent = event.currentTarget.dataset.parent;
    const category = event.currentTarget.dataset.category;
    const tags = this.state.tags;

    const index = this.state.tags
      .map(e => {
        return e.category;
      })
      .indexOf(category);
    const arr = [];

    document.getElementById(parent).innerHTML = `${
      strings.filter[event.target.dataset.category]
    }: ${event.target.innerHTML}`;
    if (index >= 0) {
      if (select != '*') {
        tags.push({ name: select, category });
      }
      tags.splice(index, 1);
    } else {
      if (select != '*') {
        tags.push({ name: select, category });
      }
    }

    tags.forEach(item => {
      arr.push(item.name);
    });

    /* Get Select */
    const group = document.getElementById('group').value;
    this.setState({ select: group });
    this.setState({ tags });
    this.setState({ arrTags: arr });
    /* Get Date */
    const objDate = JSON.parse(this.props.setting.value);
    const format = this.props.language.account.date.format;
    const date = ObjGeneral.getDate({}, format);

    /* Fetch */

    await this.props.actions.fetchSummaryNfaTableApi({
      dateStart: date.fechaStartFinal,
      dateEnd: date.fechaEndFinal,
      main: group,
      sort: this.state.sort,
      tags: arr,
      pag: 1
    });
    await this.props.actions.fetchSummaryNfaApi({
      dateStart: date.fechaStartFinal,
      dateEnd: date.fechaEndFinal,
      main: group,
      sort: this.state.sort,
      tags: arr,
      pag: 1
    });
    await this.props.actions.fetchSummaryNfaTableCountApi({
      dateStart: date.fechaStartFinal,
      dateEnd: date.fechaEndFinal,
      main: group,
      pag: 1,
      tags: arr
    });

    await this.props.actions.fetchSummaryNfaBPMApi({
      dateStart: date.fechaStartFinal,
      dateEnd: date.fechaEndFinal,
      main: group,
      sort: this.state.sort,
      tags: arr,
      pag: 1
    });
  };

  // function performed to paginate
  handleScroll = async event => {
    if (!event.target.dataset.nonescroll) {
      if (!this.props.loadingTableSpiner) {
        if (this.state.pag < this.props.count.pages) {
          const scroll = event.target.scrollTop;
          const max = event.target.scrollHeight - event.target.offsetHeight;
          if (scroll >= max) {
            /* Change Pag */
            this.setState({
              pag: this.state.pag + 1
            });
            const pag = this.state.pag + 1;
            /* Get Date */
            const objDate = JSON.parse(this.props.setting.value);
            const format = this.props.language.account.date.format;
            const date = ObjGeneral.getDate({ id: null }, format);
            /* Fetch */
            await this.props.actions.fetchSummaryNfaBPMApi({
              pag,
              concat: true,
              main: this.state.select,
              dateStart: date.fechaStartFinal,
              dateEnd: date.fechaEndFinal
            });
            await this.props.actions.fetchSummaryNfaTableNoLoadingApi({
              pag,
              concat: true,
              main: this.state.select,
              dateStart: date.fechaStartFinal,
              dateEnd: date.fechaEndFinal
            });
          }
        }
      }
    }
  };

  link = event => {
    const objLink = JSON.parse(this.props.setting.value);
    const settingLink = ObjGeneral.getSetting({
      setting: objLink.summaryFatigue,
      filter: this.props.filter,
      general: objLink.generalSetting
    });
    const format = this.props.language.account.date.format;
    let tags = [];
    const date = ObjGeneral.getDate({ id: null }, format);

    if (event.currentTarget.dataset.datos) {
      const objDatosLink = JSON.parse(event.currentTarget.dataset.datos);
      settingLink.filter.forEach(item => {
        if (item.name == this.state.select) {
          tags.push(objDatosLink.alias);
        } else {
          tags.push('TODOS');
        }
      });
    } else {
      tags = ObjGeneral.getTags({ id: null });
    }
    document.getElementById('menu-12-sub-1').classList.remove('active');
    document.getElementById('menu-12-sub-2').classList.add('active');
    this.props.detailActions.setFilterDetailNfa({
      tags,
      date
    });
    this.props.history.push('/dashboard/detail_nfa');
  };

  render() {
    // the setting object is obtained which we use for the configuration
    const obj = JSON.parse(this.props.setting.value);

    const setting = ObjGeneral.getSetting({
      setting: obj.summaryNFA,
      filter: this.props.filter,
      general: obj.generalSetting
    });

    // condition done to see if the setting was done
    if (this.props.setting) {
      const header = (
        <Header
          group={setting.group}
          select={this.state.select}
          handleSubmit={this.handleSubmit}
          language={this.props.language}
          filter={setting.filter}
          date={this.props.dateMax[5]}
          filters={this.props.filters}
        />
      );
      let container = '';
      // condition performed for loading state of the view
      if (this.props.loading || this.props.loadingTable) {
        container = <Loading language={this.props.language} />;
        // the 401 status of the application Expired token or unauthorized
      } else if (
        this.props.status === 401 ||
        this.props.statusTags === 401 ||
        this.props.statusTable === 401 ||
        this.props.statusCount === 401
      ) {
        container = <Expired history={this.props.history} />;
        // the status 200 of the application success
      } else if (
        this.props.status === 200 &&
        this.props.statusTags === 200 &&
        this.props.statusTable === 200
      ) {
        container = (
          <div className="main-container scroll">
            <TitleMain datos={this.props.datos.inRisk} language={this.props.language} />
            <Main
              link={this.link}
              datos={this.props.datos}
              title={this.props.language}
              tooltip={this.props.language.detail_fatigue.graphToolTip}
              graphColorRange={obj.graphColorRange.fatigueRiskPercentage}
              nfa={obj.nfa}
              language={this.props.language}
            />
            <TitleSecond language={this.props.language} />
            <Buttons
              tags={this.state.tags}
              graphColorRange={obj.graphColorRange.fatigueRiskPercentage}
              filter={setting.filter}
              language={this.props.language ? this.props.language : ''}
              handleTagsFilter={this.handleTagsFilter}
            />
            <Table
              link={this.link}
              pag={this.state.pag}
              range={this.state.range}
              BPM={this.props.datosBPM}
              getBPM={this.getBPM}
              nfa={obj.nfa}
              tooltip={this.props.language.detail_fatigue.graphToolTip}
              datos={this.props.datosTable}
              title={this.props.language}
              main={this.state.select}
              language={this.props.language}
              handleSort={this.handleSort}
              loadingTable={this.props.loadingTableSpiner}
              count={this.props.count}
            />
            <Tooltip placement="top" id="pageTooltip" />
          </div>
        );
      } else if (
        this.props.status === 500 ||
        this.props.statusTags === 500 ||
        this.props.statusTable === 500 ||
        this.props.statusCount === 500
      ) {
        container = <Message message={this.props.language.error.apiError500} />;
      } else {
        container = <Message message={this.props.language.error.apiError} />;
      }
      return (
        <section className="main" onScroll={this.handleScroll}>
          {header}
          {container}
        </section>
      );
    }

    return (
      <section className="main">
        <Message message="NO Setting" />
      </section>
    );
  }
}
const mapStateToProps = state => ({
  filter: state.reducer.tags.filter,
  statusTags: state.reducer.tags.status,

  setting: state.reducer.dashboard.setting,

  count: state.reducer.summaryNfa.count,
  statusCount: state.reducer.summaryNfa.statusCount,
  datos: state.reducer.summaryNfa.datos,
  loading: state.reducer.summaryNfa.loading,
  status: state.reducer.summaryNfa.status,
  datosTable: state.reducer.summaryNfa.datosTable,
  loadingTable: state.reducer.summaryNfa.loadingTable,
  statusTable: state.reducer.summaryNfa.statusTable,
  loadingTableSpiner: state.reducer.summaryNfa.loadingTableSpiner,
  filters: state.reducer.summaryNfa.filters,
  loadingBPM: state.reducer.summaryNfa.loadingBPM,
  datosBPM: state.reducer.summaryNfa.datosBPM,
  loadingNFA: state.reducer.summaryNfa.loadingNFA,
  statusBPM: state.reducer.summaryNfa.statusBPM,

  dateMax: state.reducer.dashboard.dateMax,
  language: state.reducer.dashboard.language
});
const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(summaryNfaActions, dispatch),
  detailActions: bindActionCreators(detailNfaActions, dispatch)
});
SummaryNfa.propTypes = {
  datos: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.array,
    PropTypes.object
  ]).isRequired,
  actions: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
  history: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SummaryNfa);



// WEBPACK FOOTER //
// ./source/client/containers/summary_nfa/index.jsx